import { createWebHistory, createRouter } from "vue-router";
import RedirectQr from "@/components/RedirectQr.vue";

const routes = [
  {
    path: "/q/:pid",
    name: "home",
    component: RedirectQr,
    props: true
  }

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;